import * as FullStory from '@fullstory/browser';
import { handOverToPhoneIdentity } from './fullStoryInstoreVcc';

function fullStoryIdentify({ phone, uid, firstName }) {
  try {
    // The in-store VCC flow has no uid or first name at first, so only send what exists.
    const phoneVars = {
      ...(uid && { uid_str: uid }),
      displayName: `${firstName || ''} ${phone}`.trim(),
    };

    // In-store VCC sessions start identified by store. Hand the identity over to the phone and keep the
    // flow, retailer and store properties so the INSTORE_VCC segment still matches.
    if (!handOverToPhoneIdentity(phone, phoneVars)) {
      FullStory.identify(phone, phoneVars);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('FullStory not loaded', err);
  }
}
export default fullStoryIdentify;
